import { FlagEmoji } from '@/components/atoms/FlagEmoji/FlagEmoji';
import { languageAndFlagByCountryCode } from '@/shared/languageCodes';
import { emojiFlagToCountryCode } from '@/util/emojiFlagToCountryCode';

/**
 * Maps a template language code to a country code for flag display.
 *
 * Meta's /templates API returns locales as `pt_BR`, `es_AR` etc., but
 * `languageAndFlagByCountryCode` is keyed `pt-br`, `es` (no region). Normalize
 * the input, then fall back to the language prefix when the exact locale isn't
 * mapped. Returns 'white-flag' if nothing matches.
 */
export const getCountryCodeFromLanguage = (language: string): string | null => {
  if (!language) {
    return null;
  }

  const normalized = language.replaceAll('_', '-').toLowerCase();
  const prefix = normalized.split('-')[0];
  const flagEmoji =
    languageAndFlagByCountryCode[normalized]?.flag ?? languageAndFlagByCountryCode[prefix]?.flag;
  if (!flagEmoji) {
    return 'white-flag';
  }

  try {
    return emojiFlagToCountryCode(flagEmoji);
  } catch {
    return 'white-flag';
  }
};

/** Renders a flag emoji for a template language, with white flag fallback. */
export const TemplateFlagIcon = ({ countryCode }: { countryCode: string | null }) => {
  if (!countryCode) {
    return null;
  }

  if (countryCode === 'white-flag') {
    return (
      <img
        src="/assets/white_flag_emoji.png"
        width="16"
        height="12"
        alt="white flag"
        loading="lazy"
      />
    );
  }

  return <FlagEmoji countryCode={countryCode} />;
};
